import React from 'react';

import Image from 'components/uiLibrary/Image';
import Typography from 'components/uiLibrary/Typography';

import CardWithProductionInfo from 'components/Media/Display/CardWithProductionInfo';

import classes from './MediaCard.module.scss';

const MediaCard = ({
  data,
  title,
  subTitle,
  attribution,
  attributionClassName,
  imageProps,
  imageTrackingData,
  styles,
}) => (
  <CardWithProductionInfo production={data?.production} disabled={!data?.production?.id} styles={styles}>
    <Image
      {...imageProps}
      attribution={attribution}
      attributionClassName={attributionClassName}
      className={classes.image}
      trackingData={imageTrackingData}
    />
    {(title || subTitle) && !data?.production?.id && (
      <div className={classes.mediaCard__details}>
        <Typography variant="p" weight="medium" className={classes.title}>
          {title}
        </Typography>
        <Typography color="secondary" className={classes.subTitle} size={12}>
          {subTitle}
        </Typography>
      </div>
    )}
  </CardWithProductionInfo>
);

export default MediaCard;
